var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_571_1902)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 5,
    width: 4,
    height: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7775 16.2891L11.4454 2.07031C10.8075 0.976562 9.19777 0.976562 8.55558 2.07031L0.227455 16.2891C-0.413561 17.3789 0.384838 18.75 1.66964 18.75H18.3337C19.6134 18.75 20.4142 17.3828 19.7775 16.2891ZM9.06261 6.5625C9.06261 6.04492 9.48254 5.625 10.0001 5.625C10.5177 5.625 10.9376 6.04688 10.9376 6.5625V11.5625C10.9376 12.0801 10.5177 12.5 10.0353 12.5C9.55285 12.5 9.06261 12.082 9.06261 11.5625V6.5625ZM10.0001 16.25C9.32199 16.25 8.77199 15.7 8.77199 15.0219C8.77199 14.3438 9.3216 13.7937 10.0001 13.7937C10.6786 13.7937 11.2282 14.3438 11.2282 15.0219C11.2267 15.6992 10.6798 16.25 10.0001 16.25Z",
    fill: "#F7831D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_571_1902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.eecab745baef76c406f85a13ba896269.svg";
export { ForwardRef as ReactComponent };